import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS, buildQueryString } from '../../utils/handler';
import { LEAVE_TYPE } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { GET, POST, PUT, DELETE } = HTTP_METHODS;
const { LEAVE_TYPE_GET } = LEAVE_TYPE;

export const leaveTypeApi = createApi({
  reducerPath: 'leaveTypeApi',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  endpoints: (builder) => ({
    getLeaveType: builder.query({
      query: (data) => ({ url: `${LEAVE_TYPE_GET}${buildQueryString(data)}`, method: GET })
    }),
    getLeaveTypeById: builder.query({
      query: (id) => ({ url: `${LEAVE_TYPE_GET}/byUser/${id.id}`, method: GET })
    }),
    addLeaveType: builder.mutation({
      query: (data) => ({ url: LEAVE_TYPE_GET, method: POST, data })
    }),
    deleteLeaveType: builder.mutation({
      query: (id) => ({
        url: `${LEAVE_TYPE_GET}/${id}`,
        method: DELETE
      })
    }),
    editLeaveType: builder.mutation({
      query: (data) => ({
        url: `${LEAVE_TYPE_GET}/${data.id}`,
        method: PUT,
        data: data.data
      })
    })
  })
});

export const {
  useGetLeaveTypeQuery,
  useGetLeaveTypeByIdQuery,
  useAddLeaveTypeMutation,
  useEditLeaveTypeMutation,
  useDeleteLeaveTypeMutation
} = leaveTypeApi;
